
const _ = require('lodash');

const custAcctCategory = [
  'Architect',
  'Contractor',
  'General Customer',
  'Customer Group',
  'Decorator',
  'Design Firm',
  'Developer',
  'Forwarding Agent',
  'Installer',
  'Interior Designer',
  'Purchasing Agent',
  'Retailer',
  'Site',
  'Specifier',
  'Wholeseller',
  'RBC Sales Project',
  'Aviation Project',
  'Comm Sales Project',
  'Marine Project',
  'Contract Tile Project',
];

const fullCurrency = [
  { code: 'HKD', name: 'Hong Kong Dollar', symbol: '$' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'MOP', name: 'Macau Pataca', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM' },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
  { code: 'NPR', name: 'Nepalese Rupee', symbol: '₨' },
  { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF' },
  { code: 'QAR', name: 'Qatari Riyal', symbol: 'ر.ق' },
  { code: 'ARS', name: 'Argentine Peso', symbol: '$' },
  { code: 'SGD', name: 'Singapore Dollar', symbol: '$' },
  { code: 'BRL', name: 'Brazilian Real', symbol: 'R$' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: '$' },
  { code: 'AUD', name: 'Australian Dollar', symbol: '$' },
  { code: 'BDT', name: 'Bangladeshi Taka', symbol: '৳' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
  { code: 'PHP', name: 'Philippine Peso', symbol: '₱' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
  { code: 'THB', name: 'Thai Baht', symbol: '฿' },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: '$' },
  { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr' },
  { code: 'TWD', name: 'Taiwan New Dollar', symbol: '$' },
];

const currencies = ['HKD', 'USD', 'EUR', 'GBP', 'CNY'];

const exchangeCurrency = ['HKD', 'USD', 'MOP', 'GBP', 'MYR', 'CNY',
  'EUR', 'NPR', 'AED', 'CHF', 'QAR', 'ARS', 'SGD', 'BRL', 'CAD',
  'AUD', 'BDT', 'INR', 'PHP', 'JPY', 'THB', 'NZD', 'NOK', 'TWD'];

const serviceType = ['delivery', 'installation', 'additional'];

const paymentType = ['cash', 'bank', 'cheque', 'card', 'other'];
const cardType = ['Visa', 'MasterCard', 'AE'];
const consignPaymentType = {
  lowestItemPrice: 'Full payment for the item with lowest price',
  itemPrice: 'Optional item for payment',
  customPrice: 'Customize consignment payment amount',
};

const unitOfMeasure = ['EA', 'M2', 'FT2', 'YD2', 'RL'];

const permissionSegments = [
  'departments',
  'roles',
  'customers',
  'designs',
  'stocks',
  'collections',
  'collaborators',
  'quotations',
  'consignments',
  'orders',
  'exchangeRates',
  'taxations',
  'showrooms',
  'terms',
  'services',
];

const permissionActions = ['edit', 'read', 'none'];

const erpStockStatusMap = {
  1: 'Active',
  100: 'Consigned',
  101: 'InTransit',
  102: 'Quarantined',
  103: 'Reserved',
  140: 'OnHold',
};

const arModelMap = {
  meters: {
    'Square-1_1': 0.1,
    'Rectangle-2_3': 0.1,
    'Rectangle-9_12': 0.1,
    'Rectangle-10_14': 0.1,
    'Rectangle-245_305': 0.1,
    'Circle-1_1': 0.1,
    'Oval-2_3': 0.1,
    'Oval-9_12': 0.1,
    'Oval-10_14': 0.1,
    'Oval-245_305': 0.1,
  },
  opacity: [
    'Irregular-250_350',
  ],
};

const arModels = _.uniq([
  ..._.keys(arModelMap.meters),
  ...arModelMap.opacity,
]);

const tfyMeasureUnits = [
  'm',
  'ft',
  'yd',
];

const tfySqMeasureUnits = [
  'm2',
  'ft2',
  'yd2',
];

module.exports = {
  custAcctCategory,
  currencies,
  serviceType,
  paymentType,
  consignPaymentType,
  cardType,
  exchangeCurrency,
  unitOfMeasure,
  erpStockStatusMap,
  permissionSegments,
  permissionActions,
  fullCurrency,
  arModels,
  arModelMap,
  tfyMeasureUnits,
  tfySqMeasureUnits,
};
